import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { PAID_AMOUNT_COLUMNS } from './PaidAmountTable.config';
import styles from './PaidAmountTable.styles.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

const PaidAmountTable = ({ prepayment }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={cn(styles['table-header'])}>
        <span>{t('createInvoice.paid_amount')}</span>
        <span>
          {Number(
            prepayment.reduce((acc, item) => acc + Number(item.paidAmount), 0),
          ).toFixed(3) + ' BHD'}
        </span>
      </div>
      <div className={styles['table-container']}>
        <DataTable
          scrollable
          scrollHeight="400px"
          value={prepayment}
          tableStyle={{ minWidth: '50rem' }}
          className={styles.paymentDatatable}
        >
          {PAID_AMOUNT_COLUMNS.map((col, i) => (
            <Column
              className={styles['table-columns']}
              key={col.key}
              field={col.key}
              body={col.body}
              header={t(col.label)}
              minWidth={'50rem'}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default React.memo(PaidAmountTable);
